import http from "@/http/aisea/axios";
const resource = "/gkmg/port_master/enterprises/tasks";

export default {
  export(date) {
    return http.get(`${resource}/exports/${date}`, {
      responseType: "blob",
    });
  },
};
